import { useState, useCallback } from 'react';

/**
 * Like useState for page size, but persists to localStorage.
 * Values can be a positive number or 'all'.
 *
 * @param {string} key           localStorage key, e.g. 'pg_trades'
 * @param {number|'all'} defaultSize  fallback if nothing in storage
 * @returns {[number|'all', function]}
 */
export function usePersistentPageSize(key, defaultSize) {
  const [pageSize, _setPageSize] = useState(() => {
    try {
      const saved = localStorage.getItem(key);
      if (saved !== null) {
        const val = JSON.parse(saved);
        if (val === 'all' || (typeof val === 'number' && val > 0)) return val;
      }
    } catch {}
    return defaultSize;
  });

  const setPageSize = useCallback((val) => {
    _setPageSize(val);
    try { localStorage.setItem(key, JSON.stringify(val)); } catch {}
  }, [key]);

  return [pageSize, setPageSize];
}
